import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AmcService {

    constructor(private http: HttpClient) { }
    getAMCStatus(data:any): Observable<any> {
        return this.http.post(environment.getAMCStatus,data);
      }
    getPackages(data:any): Observable<any> {
        return this.http.post(environment.getPackages,data);
    }
      
}